<template>
  <Modal
    :title="$t('create_item_size')"
    modalId="create-modal"
    @submit="submitItemSize"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitItemSize">
      <div class="mb-3">
        <label class="form-label">
          {{ $t('item_size_name') }} <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          v-model="itemSize.size"
          class="form-control"
        />
        <div v-if="errors.size" class="text-danger mt-2">
          <span>{{ errors.size }}</span>
        </div>
      </div>
      <div v-if="errorMessage" class="text-danger mt-2">
        {{ errorMessage }}
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue"; // Import Modal component
import apiUrls from "../../../urls"; // Import API URLs

export default {
   components: {
      Modal,
    },
   data() {
    return {
      itemSize: {
        size: '',
      },
      errors: {},
      errorMessage: "",
    };
  },

  methods: {
      async submitItemSize() {
        // Frontend validation before making API call
          this.errors = {};
          if (!this.itemSize.size.trim()) this.errors.size = this.$t('error.required');

          if (Object.keys(this.errors).length > 0) {
          return; // Stop execution if validation fails
        }

        try {
          const formData = new FormData();
          Object.keys(this.itemSize).forEach((key) => {
            formData.append(key, this.itemSize[key]);
          });
          // Send API request
          const response = await this.$axios.post(apiUrls.item_size.post, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          // Close modal after success
          const modal = document.getElementById("create-modal4");
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) modalInstance.hide();

          // Emit event to update parent component
          this.$emit("create_success", response.data);

          this.resetForm();
        } catch (error) {
          if (error.response?.data?.error) {
            this.errorMessage = error.response.data.error;
          }

          // Handle field-specific errors dynamically
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors; // Dynamically set field errors
          }
        }
      },
      resetForm() {
      // Reset form fields and errors
      this.itemSize.size = "";
      this.errors = {};
      this.errorMessage = "";
    }
  },
};
</script>
